import type { ProcessFlowState } from './_state.type';

/** ProcessFlow State. */
export const processFlowState: ProcessFlowState = {
  processFlow: {},

  barCodeZone: {
    show: false,
  },
};
